<template>
  <div class="app">
    <ul class="user-info">
      <li>
        <span class="left">姓名</span>
        <span class="right">{{ medicalInfo.userName }}</span>
      </li>
      <li>
        <span class="left">身份证号码</span>
        <span class="right">{{ medicalInfo.idcard | dotted }}</span>
      </li>
      <li>
        <span class="left">性别</span>
        <span class="right">{{ medicalInfo.sex }}</span>
      </li>
      <li>
        <span class="left">年龄</span>
        <span class="right">{{ medicalInfo.age }}</span>
      </li>
      <li>
        <span class="left">联系电话</span>
        <span class="right">{{ medicalInfo.phone | dotted }}</span>
      </li>
      <li>
        <span class="left">签约机构</span>
        <span class="right">{{ medicalInfo.hospitalName }}</span>
      </li>
      <li>
        <span class="left">团队名称</span>
        <span class="right">{{ medicalInfo.doctorGroupName }}</span>
      </li>
    </ul>
    <div class="img">
      <img src="../../../static/img/gongzonghao.jpg" alt="" />
    </div>
    <div class="code-tips">
      <h3>温馨提示</h3>
      <p>
        请长按二维码关注彭州市家庭医生公众号,快捷发起家庭医生服务.若您有任何签约家庭医生相关的疑问,
        请您联系“{{ medicalInfo.hospitalName }}”咨询。电话:{{
          medicalInfo.telephone
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      medicalInfo: {},
    }
  },
  created () {
    this.medicalInfo = this.$route.query
    this.medicalInfo.sex = this.medicalInfo.sex == 0 ? '女' : '男'
  }
}
</script>

<style lang="scss" scoped>
.app {
  background-color: #eff3f6;
  .user-info {
    margin: 0.3rem 0;
    background-color: #fff;
    li {
      height: 1rem;
      line-height: 1rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.85rem;
      border-bottom: 0.05rem solid #f0f1f5;
      &:last-child {
        border: none;
      }
      .left {
        color: #a2a2a2;
      }
    }
  }
  .img {
    text-align: center;
    padding: 0.5rem 0;
    background-color: #fff;
    img {
      height: 7.125rem;
    }
  }
  .code-tips {
    padding: 0 0.5rem;
    h3 {
      height: 1rem;
      line-height: 1rem;
      margin: 0;
      color: #3d3d3d;
      text-align: left;
    }
    p {
      color: #999a9c;
      word-break: break-all;
      line-height: 1.125rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Signed.vue?4e59531e